import { withProps } from 'recompose';
import { FieldArray } from 'redux-form';
import TypedCollectionInner from './TypedCollectionInner';

const validateAtLeastOne = (values) =>
    (!values || 0 === values.length ? 'Veuillez sélectionner au moins un produit.' : undefined);

// Référence stable : redux-form re-enregistre le validateur si le tableau change à chaque render
const atLeastOneValidators = [validateAtLeastOne];

const TypedCollection = withProps(({ required }) => ({
    component: TypedCollectionInner,
    validate: required ? atLeastOneValidators : undefined,
}))(FieldArray);

export default TypedCollection;
